import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { moneyAccurate as money } from 'app/helpers/money';
import Expander from './Expander';
import { useContext } from './useFormContext';
import {
  EffectivePaysystemLimitStat,
  EffectivePaysystemLimitStats,
  EffectivePlayerLimitStat,
  EffectivePlayerLimitStats,
} from './useLimitStats';

const PaysystemLimitRow: FC<{ stat: EffectivePaysystemLimitStat }> = ({
  stat: { period, limit, usage, excess, currency },
}) => (
  <div
    role="row"
    className={classnames({ error: excess }, 'rs-flex rs-gap_small__zero')}
    key={period}
    data-period={period}
  >
    <div className="rs-flex-item rs-medium-4">{period}</div>
    <div className="rs-flex-item rs-medium-4 rs-text-align_right value">{money(limit, currency)}</div>
    <div className="rs-flex-item rs-medium-4 rs-text-align_right value">{money(usage, currency)}</div>
  </div>
);

const PlayerLimitRow: FC<{ stat: EffectivePlayerLimitStat }> = ({ stat: { text, limit, usage, excess, currency } }) => (
  <div role="row" className={classnames({ error: excess }, 'rs-flex rs-gap_small__zero player')}>
    <div className="rs-flex-item rs-medium-4 name">{text}</div>
    <div className="rs-flex-item rs-medium-4 rs-text-align_right value">{money(limit, currency)}</div>
    <div className="rs-flex-item rs-medium-4 rs-text-align_right value">{money(usage, currency)}</div>
  </div>
);

const LimitsUsage: FC<{
  effectivePaysystemLimitStats: EffectivePaysystemLimitStats;
  effectivePlayerLimitStats: EffectivePlayerLimitStats;
}> = ({ effectivePaysystemLimitStats, effectivePlayerLimitStats }) => {
  const { locales } = useContext();

  return (
    <Expander text={locales.details} className="limits-usage js-limits-usage">
      <div className="rs-flex rs-gap_small__zero">
        <div className="rs-flex-item rs-medium-4">&nbsp;</div>
        <div className="rs-flex-item rs-medium-4 rs-text-align_right">
          <strong>{locales.limit}</strong>
        </div>
        <div className="rs-flex-item rs-medium-4 rs-text-align_right">
          <strong>{locales.now}</strong>
        </div>
      </div>
      {effectivePaysystemLimitStats.map((stat) => (
        <PaysystemLimitRow stat={stat} key={stat.period} />
      ))}
      {effectivePaysystemLimitStats.length && effectivePlayerLimitStats && <hr />}
      {effectivePlayerLimitStats && <PlayerLimitRow stat={effectivePlayerLimitStats} />}
    </Expander>
  );
};

export default LimitsUsage;
